// @flow
/* eslint arrow-parens:0 */
/* eslint no-duplicate-imports:0 */

import app from 'app/common/redux/reducers/ui/app';
import checklist from './checklist';
import contentSafetyModal from 'app/common/redux/reducers/ui/contentSafetyModal';
import conversations from 'app/common/redux/reducers/ui/conversations';
import gdprModal from 'app/common/redux/reducers/ui/gdprModal';
import header from 'app/common/redux/reducers/ui/header';
import login from 'app/common/redux/reducers/ui/login';
import mainComponent from 'app/common/redux/reducers/ui/mainComponent';
import notifications from 'app/common/redux/reducers/ui/notifications';
import nuxProgress from 'app/common/redux/reducers/ui/nuxProgress';
import nuxSelectedInterestImages from 'app/common/redux/reducers/ui/nuxSelectedInterestImages';
import postRepinMoreIdeasUpsell from 'app/common/redux/reducers/ui/postRepinMoreIdeasUpsell';
import reportData from 'app/common/redux/reducers/ui/reportData';
import toasts from 'app/common/redux/reducers/ui/toasts';
import type { State as App } from 'app/common/redux/reducers/ui/app';
import type { State as Checklist } from 'app/common/redux/reducers/ui/checklist';
import type { State as ContentSafetyModal } from 'app/common/redux/reducers/ui/contentSafetyModal';
import type { State as Conversations } from 'app/common/redux/reducers/ui/conversations';
import type { State as GDPRModal } from 'app/common/redux/reducers/ui/gdprModal';
import type { State as Header } from 'app/common/redux/reducers/ui/header';
import type { State as Login } from 'app/common/redux/reducers/ui/login';
import type { State as MainComponent } from 'app/common/redux/reducers/ui/mainComponent';
import type { State as Notifications } from 'app/common/redux/reducers/ui/notifications';
import type { State as NuxProgress } from 'app/common/redux/reducers/ui/nuxProgress';
import type { State as NuxSelectedInterestImages } from 'app/common/redux/reducers/ui/nuxSelectedInterestImages';
import type { State as PostRepinMoreIdeasUpsell } from 'app/common/redux/reducers/ui/postRepinMoreIdeasUpsell';
import type { State as ReportData } from 'app/common/redux/reducers/ui/reportData';
import type { State as Toasts } from 'app/common/redux/reducers/ui/toasts';
import type { State as Views } from 'app/common/redux/reducers/ui/views';
import type { State as VisualLinks } from 'app/common/redux/reducers/ui/visualLinks';
import views from 'app/common/redux/reducers/ui/views';
import visualLinks from 'app/common/redux/reducers/ui/visualLinks';
import { combineReducers } from 'redux';

export type State = {
  app: App,
  checklist: Checklist,
  contentSafetyModal: ContentSafetyModal,
  conversations: Conversations,
  gdprModal: GDPRModal,
  header: Header,
  login: Login,
  mainComponent: MainComponent,
  notifications: Notifications,
  nuxSelectedInterestImages: NuxSelectedInterestImages,
  nuxProgress: NuxProgress,
  postRepinMoreIdeasUpsell: PostRepinMoreIdeasUpsell,
  reportData: ReportData,
  toasts: Toasts,
  views: Views,
  visualLinks: VisualLinks,
};

export type CommonUiState = {
  app: App,
  contentSafetyModal: ContentSafetyModal,
  conversations: Conversations,
  gdprModal: GDPRModal,
  header: Header,
  login: Login,
  mainComponent: MainComponent,
  nuxSelectedInterestImages: NuxSelectedInterestImages,
  nuxProgress: NuxProgress,
  toasts: Toasts,
  views: Views,
  visualLinks: VisualLinks,
};

export type AuthUiState = CommonUiState & {
  postRepinMoreIdeasUpsell: PostRepinMoreIdeasUpsell,
};

export const commonReducers = {
  contentSafetyModal,
  conversations,
  gdprModal,
  mainComponent,
  login,
  toasts,
  visualLinks,
};

// TODO:mjennings- start moving commonReducers that are not actualy common into authReducers/unAuthReducers etc
// export authUI, unauthUI, commonUI etc instead of just ui
export const authReducers = {
  app,
  checklist,
  header,
  notifications,
  nuxSelectedInterestImages,
  nuxProgress,
  postRepinMoreIdeasUpsell,
  reportData,
  views,
};

// $FlowFixMe: new errors found from flow 0.96 upgrade
export const authUi = combineReducers({
  ...commonReducers,
  ...authReducers,
});

// $FlowFixMe: new errors found from flow 0.96 upgrade
export const commonUi = combineReducers(commonReducers);

export default null;
